import React, { useState } from 'react';
import {
  Box,
  Heading,
  VStack,
  Text,
  Input,
  Button,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  Icon,
} from '@chakra-ui/react';
import { AiOutlineFileSearch, AiOutlinePhone } from 'react-icons/ai';

export const DownloadReport = () => {
  const [orderId, setOrderId] = useState('');
  const [phone, setPhone] = useState('');

  const handleSearch = () => {
    // Logic to search and download report
    console.log('Searching for:', orderId, phone);
  };

  return (
    <Box>
      <VStack spacing={12} py={20} px={5}>
        <VStack spacing={3} textAlign="center">
          <Heading color="teal.700">Download Diagnostic Report</Heading>
          <Text color="gray.600">Enter your details to access your reports securely.</Text>
        </VStack>

        <Box
          p={[6, 10]}
          bg="white"
          borderRadius="3xl"
          boxShadow="2xl"
          width={['100%', '450px']}
          border="1px solid"
          borderColor="teal.50"
        >
          <VStack spacing={6}>
            <FormControl>
              <FormLabel>Order ID</FormLabel>
              <InputGroup size="lg">
                <InputLeftElement children={<Icon as={AiOutlineFileSearch} color="gray.400" />} />
                <Input
                  placeholder="e.g. DLAB123456"
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                  focusBorderColor="teal.400"
                />
              </InputGroup>
            </FormControl>

            <FormControl>
              <FormLabel>Phone Number</FormLabel>
              <InputGroup size="lg">
                <InputLeftElement children={<Icon as={AiOutlinePhone} color="gray.400" />} />
                <Input
                  placeholder="Registered Phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  focusBorderColor="teal.400"
                />
              </InputGroup>
            </FormControl>

            <Button
              colorScheme="teal"
              size="lg"
              width="100%"
              onClick={handleSearch}
              boxShadow="lg"
              _hover={{ transform: 'translateY(-2px)', boxShadow: 'xl' }}
            >
              Search & Download
            </Button>

            <Text fontSize="sm" color="gray.400" textAlign="center">
              Your reports are encrypted and strictly confidential.
            </Text>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};
